import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components.css';

const PatientAccountDeletion = () => {
  return (
    <div className="patient-account-deletion">
      <div className="deletion-container">
        <div className="deletion-header">
          <h1>Patient Account Deletion</h1>
          <p>Instructions for deleting your Care360™ mobile app account</p>
        </div>

        <div className="deletion-content">
          <div className="deletion-section">
            <h2>How to Delete Your Account</h2>
            <p>
              To delete your Care360™ mobile app account and remove all associated data, 
              please follow these steps:
            </p>
            
            <ol className="deletion-steps">
              <li>
                <strong>Open the Care360™ app</strong> on your mobile device
              </li>
              <li>
                <strong>Sign in</strong> to your account if you're not already signed in
              </li>
              <li>
                <strong>Navigate to Profile</strong> by tapping the profile icon or menu
              </li>
              <li>
                <strong>Go to Support</strong> section within your profile
              </li>
              <li>
                <strong>Tap "Delete Account"</strong> to initiate the account deletion process
              </li>
              <li>
                <strong>Confirm deletion</strong> when prompted
              </li>
            </ol>
          </div>

          <div className="deletion-section">
            <h2>What Happens When You Delete Your Account</h2>
            <ul className="deletion-effects">
              <li>Your account will be permanently deleted</li>
              <li>All personal health information will be removed</li>
              <li>Your care team messages will be deleted</li>
              <li>Appointment history will be erased</li>
              <li>You will be automatically logged out of the app</li>
              <li>You will no longer have access to the patient portal</li>
            </ul>
          </div>

          <div className="deletion-section">
            <h2>Important Notes</h2>
            <div className="deletion-notes">
              <p>
                <strong>⚠️ Warning:</strong> Account deletion is permanent and cannot be undone. 
                Please ensure you have saved any important information before proceeding.
              </p>
              <p>
                <strong>📱 Mobile App Only:</strong> This deletion process only affects your 
                Care360™ mobile app account. If you have other accounts with our healthcare 
                system, they will remain unaffected.
              </p>
              <p>
                <strong>🏥 Healthcare Records:</strong> Deleting your app account does not 
                affect your medical records maintained by your healthcare providers. Those 
                records are kept according to applicable healthcare regulations.
              </p>
            </div>
          </div>

          <div className="deletion-section">
            <h2>Need Help?</h2>
            <p>
              If you have any questions about account deletion or need assistance, 
              please contact your healthcare provider or our support team.
            </p>
          </div>

          <div className="deletion-actions">
            <Link to="/login" className="back-to-login-btn">
              ← Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAccountDeletion;
